module.exports = {
  id: 37,
  name: 'Split Jumps',
  categories: ['cardio', 'strength', 'legs', 'coordination'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Power',
  points: 24,
  instructions:
    'Split jumps are dynamic! Jump and switch your legs in the air - one leg forward, one back! This builds incredible leg power and coordination!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to split jump like a ninja? Let us build incredible leg power and coordination!',
    },
    {
      time: 3,
      text: 'Stand with your feet together, ready to jump!',
    },
    {
      time: 6,
      text: 'Keep your core engaged and get ready to be dynamic!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Jump up high and split your legs!',
    },
    // SET 1 - 8 split jumps
    {
      time: 12,
      text: 'Perfect position! Feet together, ready to jump!',
    },
    {
      time: 15,
      text: 'Number 1! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 18,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 21,
      text: 'Number 2! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 24,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 27,
      text: 'Number 3! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 30,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 33,
      text: 'Number 4! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 36,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 39,
      text: 'Number 5! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 42,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 45,
      text: 'Number 6! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 48,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 51,
      text: 'Number 7! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 54,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 57,
      text: 'Number 8! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 60,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 63,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 1 - 25 seconds
    {
      time: 66,
      text: 'Take a deep breath in and out, you are building incredible power!',
    },
    {
      time: 69,
      text: 'Shake out your legs and feet, get ready for round two!',
    },
    {
      time: 72,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 75,
      text: 'Remember to jump high and split your legs in the air!',
    },
    {
      time: 78,
      text: '3, 2, 1, START! Jump up high and split your legs!',
    },
    // SET 2 - 8 split jumps
    {
      time: 81,
      text: 'Perfect position! Feet together, ready to jump!',
    },
    {
      time: 84,
      text: 'Number 1! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 87,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 90,
      text: 'Number 2! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 93,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 96,
      text: 'Number 3! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 99,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 102,
      text: 'Number 4! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 105,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 108,
      text: 'Number 5! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 111,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 114,
      text: 'Number 6! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 117,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 120,
      text: 'Number 7! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 123,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 126,
      text: 'Number 8! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 129,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 132,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 2 - 25 seconds
    {
      time: 135,
      text: 'Take a deep breath in and out, you are building incredible power!',
    },
    {
      time: 138,
      text: 'Shake out your legs and feet, get ready for the final round!',
    },
    {
      time: 141,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 144,
      text: 'Remember to jump high and split your legs in the air!',
    },
    {
      time: 147,
      text: '3, 2, 1, START! Jump up high and split your legs!',
    },
    // SET 3 - 8 split jumps
    {
      time: 150,
      text: 'Perfect position! Feet together, ready to jump!',
    },
    {
      time: 153,
      text: 'Number 1! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 156,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 159,
      text: 'Number 2! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 162,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 165,
      text: 'Number 3! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 168,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 171,
      text: 'Number 4! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 174,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 177,
      text: 'Number 5! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 180,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 183,
      text: 'Number 6! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 186,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 189,
      text: 'Number 7! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 192,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 195,
      text: 'Number 8! Jump up high and split your legs - one forward, one back!',
    },
    {
      time: 198,
      text: 'Land softly and switch your legs in the air!',
    },
    {
      time: 201,
      text: 'Incredible work! You are done! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 204,
      text: 'Amazing work! You did 24 split jumps and built incredible power!',
    },
    {
      time: 207,
      text: 'You are getting super dynamic and powerful! You are a split jump ninja!',
    },
    {
      time: 210,
      text: 'Great job, power champion! You are building incredible skills!',
    },
  ],
};
